/**
 * Session and Inactivity configuration constants.
 */

// 1 minute in milliseconds (FOR TESTING)
export const SESSION_TIMEOUT_MS = 15 * 60 * 1000;

// Proactively refresh the token if user is active and it's been > 20 seconds since last refresh
export const PROACTIVE_REFRESH_THRESHOLD_MS = 20 * 1000;

// Throttle activity tracking to once every 2 seconds
export const ACTIVITY_THROTTLE_MS = 2000;

// Interval to check session status
export const SESSION_CHECK_INTERVAL_MS = 10 * 1000;
